import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  HomeIcon as HomeOutline,
  UserGroupIcon as GroupOutline,
  UserIcon as UserOutline
} from '@heroicons/react/24/outline';
import {
  HomeIcon as HomeSolid,
  UserGroupIcon as GroupSolid,
  UserIcon as UserSolid
} from '@heroicons/react/24/solid';

const BottomNavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      label: 'Beranda',
      path: '/dashboard',
      iconOutline: HomeOutline,
      iconSolid: HomeSolid
    },
    {
      label: 'Grup',
      path: '/dashboard',
      iconOutline: GroupOutline,
      iconSolid: GroupSolid,
      match: '/group'
    },
    {
      label: 'Profil',
      path: '/profile',
      iconOutline: UserOutline,
      iconSolid: UserSolid
    }
  ];

  const isActive = (item) => {
    if (item.match) {
      return location.pathname.startsWith(item.match);
    }
    return location.pathname === item.path;
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-border z-40 px-6 pb-safe" data-testid="bottom-nav">
      <div className="max-w-md mx-auto flex items-center justify-around py-2">
        {navItems.map((item) => {
          const active = isActive(item);
          const Icon = active ? item.iconSolid : item.iconOutline;
          return (
            <button
              key={item.label}
              onClick={() => navigate(item.path)}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={`flex flex-col items-center gap-1 py-2 px-4 rounded-2xl transition-all ${
                active
                  ? 'text-primary'
                  : 'text-slate-400 hover:text-slate-600'
              }`}
            >
              <Icon className="w-6 h-6" />
              <span className="text-[10px] font-semibold">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavBar;
